<template>
  <div>
    <v-content class="pa-5" style="height: 100%">
      <v-layout justify-center>
        <v-flex xs10>
          <Header title="Power BI"></Header>
          <!-- Main page -->
          <v-layout v-if="section === 'main-page'">
            <v-flex xs10>
              <v-layout justify-center>
                <v-layout column>
                  <v-flex mb-5 text-start>
                    <v-layout justify-start cea-color txt-head mb-3>
                      <h1>Main page</h1>
                    </v-layout>
                    <!--  POWER BI International-->
                    <div>
                      <v-layout column>
                        <v-flex mb-5 text-start>
                          <v-layout justify-start cea-color txt-head mb-3>
                            International
                          </v-layout>
                          <div class="mb-7 cea-underline"></div>
                        </v-flex>
                        <v-layout column>
                          <v-flex mb-5 text-start>
                            <div v-for="(item, i) in powerBiDataOverviewInternational" :key="i" class="mb-7 banner-box">
                              <v-btn absolute top fab x-small color="#FF4F23" style="right: -12px"
                                @click="removePowerBI(item.id)">
                                <v-icon color="white">close</v-icon>
                              </v-btn>
                              <v-layout justify-start cea-color txt-head mb-3>
                                International
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Subject TH: </v-flex>
                                <v-flex xs8>
                                  <v-text-field clearable solo flat pl-3 v-model="item.subject_th"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Subject EN: </v-flex>
                                <v-flex xs8>
                                  <v-text-field clearable solo flat pl-3 v-model="item.subject_en"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Embedded URL TH : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat pl-3 v-model="item.embed_url_th"></v-textarea>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Embedded URL EN : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat pl-3 v-model="item.embed_url_en"></v-textarea>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-10 mr-5> Description TH : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat ml-5 v-model="item.description_th"></v-textarea>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-10 mr-5> Description EN : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat ml-5 v-model="item.description_en"></v-textarea>
                                </v-flex>
                              </v-layout>
                            </div>
                            <div style="display: flex; justify-content: right">
                              <v-btn color="#FF4F23" class="white--text mb-3" @click="addMorePowerBI('International')">
                                <v-icon>add</v-icon>
                              </v-btn>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </div>

                    <!--  POWER BI Country-->
                    <div>
                      <v-layout column>
                        <v-flex mb-5 text-start>
                          <v-layout justify-start cea-color txt-head mb-3>
                            Country
                          </v-layout>
                          <div class="mb-7 cea-underline"></div>
                        </v-flex>
                        <v-layout column>
                          <v-flex mb-5 text-start>
                            <div v-for="(item, i) in powerBiDataOverviewCountry" :key="i" class="mb-7 banner-box">
                              <v-btn absolute top fab x-small color="#FF4F23" style="right: -12px"
                                @click="removePowerBI(item.id)">
                                <v-icon color="white">close</v-icon>
                              </v-btn>
                              <v-layout justify-start cea-color txt-head mb-3>
                                Country
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Subject TH: </v-flex>
                                <v-flex xs8>
                                  <v-text-field clearable solo flat pl-3 v-model="item.subject_th"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Subject EN: </v-flex>
                                <v-flex xs8>
                                  <v-text-field clearable solo flat pl-3 v-model="item.subject_en"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Embedded URL TH : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat pl-3 v-model="item.embed_url_th"></v-textarea>
                                  <!--                                    v-model="powerBi['international-power-bi'].embed_url"-->
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Embedded URL EN : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat pl-3 v-model="item.embed_url_en"></v-textarea>
                                  <!--                                    v-model="powerBi['international-power-bi'].embed_url"-->
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-10 mr-5> Description TH : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat ml-5 v-model="item.description_th"></v-textarea>
                                  <!--                                    v-model="powerBi['international-power-bi'].embed_url"-->
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-10 mr-5> Description EN : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat ml-5 v-model="item.description_en"></v-textarea>
                                  <!--                                    v-model="powerBi['international-power-bi'].embed_url"-->
                                </v-flex>
                              </v-layout>
                            </div>
                            <div style="display: flex; justify-content: right">
                              <v-btn color="#FF4F23" class="white--text mb-3" @click="addMorePowerBI('Country')">
                                <v-icon>add</v-icon>
                              </v-btn>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-layout>
              <v-layout justify-end>
                <v-btn large color="#FF4F23" class="white--text mb-3" @click="savePowerBI">บันทึก</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- Creative Index page -->
          <v-layout v-if="section === 'creative-index-page'">
            <v-flex xs10>
              <v-layout justify-center>
                <v-layout column>
                  <v-flex mb-5 text-start>
                    <v-layout justify-start cea-color txt-head mb-3>
                      <h1>Creative index page</h1>
                    </v-layout>
                    <!--  POWER BI International-->
                    <div>
                      <v-layout column>
                        <v-flex mb-5 text-start>
                          <v-layout justify-start cea-color txt-head mb-3>
                            International
                          </v-layout>
                          <div class="mb-7 cea-underline"></div>
                        </v-flex>
                        <v-layout column>
                          <v-flex mb-5 text-start>
                            <draggable :list="powerBiDataInternational" :disabled="!enabled" class="list-group"
                              ghost-class="ghost" :move="checkMoveInter" @start="dragging = true" @end="dragging = false">
                              <!--                   powerBiDataInternational powerBiDataCountry   -->
                              <div v-for="(item, i) in powerBiDataInternational" :key="i" class="mb-7 banner-box">
                                <v-btn absolute top fab x-small color="#FF4F23" style="right: -12px"
                                  @click="removePowerBI(item.id)">
                                  <v-icon color="white">close</v-icon>
                                </v-btn>
                                <v-layout justify-start cea-color txt-head mb-3>
                                  Section {{ i + 1 }}
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Subject TH: </v-flex>
                                  <v-flex xs8>
                                    <v-text-field clearable solo flat pl-3 v-model="item.subject_th"></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Subject EN: </v-flex>
                                  <v-flex xs8>
                                    <v-text-field clearable solo flat pl-3 v-model="item.subject_en"></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-10 mr-5> Title TH : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat ml-5 v-model="item.title_th"></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-10 mr-5> Title EN : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat ml-5 v-model="item.title_en"></v-textarea>
                                  </v-flex>

                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Embedded URL TH : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.embed_url_th"></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Embedded URL EN : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.embed_url_en"></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Description TH : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.description_th"></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Description EN : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.description_en"></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3>Link : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.link"></v-textarea>
                                  </v-flex>
                                </v-layout>

                              </div>
                            </draggable>
                            <div style="display: flex; justify-content: right">
                              <v-btn color="#FF4F23" class="white--text mb-3"
                                @click="addMorePowerBI('International-Creative')">
                                <v-icon>add</v-icon>
                              </v-btn>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </div>

                    <!--  POWER BI Country-->
                    <div>
                      <v-layout column>
                        <v-flex mb-5 text-start>
                          <v-layout justify-start cea-color txt-head mb-3>
                            Country
                          </v-layout>
                          <div class="mb-7 cea-underline"></div>
                        </v-flex>
                        <v-layout column>
                          <v-flex mb-5 text-start>
                            <draggable :list="powerBiDataCountry" :disabled="!enabled" class="list-group"
                              ghost-class="ghost" :move="checkMoveCountry" @start="dragging = true"
                              @end="dragging = false">
                              <div v-for="(item, i) in powerBiDataCountry" :key="i" class="mb-7 banner-box">
                                <v-btn absolute top fab x-small color="#FF4F23" style="right: -12px"
                                  @click="removePowerBI(item.id)">
                                  <v-icon color="white">close</v-icon>
                                </v-btn>
                                <v-layout justify-start cea-color txt-head mb-3>
                                  Section {{ i + 1 }}
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Subject TH: </v-flex>
                                  <v-flex xs8>
                                    <v-text-field clearable solo flat pl-3 v-model="item.subject_th"></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Subject EN: </v-flex>
                                  <v-flex xs8>
                                    <v-text-field clearable solo flat pl-3 v-model="item.subject_en"></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-10 mr-5> Title TH : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat ml-5 v-model="item.title_th"></v-textarea>
                                  </v-flex>

                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-10 mr-5> Title EN : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat ml-5 v-model="item.title_en"></v-textarea>
                                  </v-flex>

                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Embedded URL TH : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.embed_url_th"></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Embedded URL EN : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.embed_url_en"></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Description Embed TH : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.description_th"></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3> Description Embed EN : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.description_en"></v-textarea>
                                  </v-flex>
                                </v-layout>
                                <v-layout justify-end>
                                  <v-flex shrink pt-3 ml-5 mr-3>Link : </v-flex>
                                  <v-flex xs8>
                                    <v-textarea clearable solo flat pl-3 v-model="item.link"></v-textarea>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </draggable>
                            <div style="display: flex; justify-content: right">
                              <v-btn color="#FF4F23" class="white--text mb-3" @click="addMorePowerBI('Country-Creative')">
                                <v-icon>add</v-icon>
                              </v-btn>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </div>

                  </v-flex>
                </v-layout>
              </v-layout>
              <v-layout justify-end>
                <v-btn large color="#FF4F23" class="white--text mb-3" @click="savePowerBI">บันทึก</v-btn>
              </v-layout>
            </v-flex>

          </v-layout>
          <!-- Data and Static page -->
          <v-layout v-if="section === 'data-and-static-page'">
            <v-flex xs10>
              <v-layout justify-center>
                <v-layout column>
                  <v-flex mb-5 text-start>
                    <v-layout justify-start cea-color txt-head mb-3>
                      <h1>Data and Static page</h1>
                    </v-layout>
                    <!--  POWER BI by Category-->
                    <div>
                      <v-layout column>
                        <v-flex mb-5 text-start>
                          <v-layout justify-start cea-color txt-head mb-3>
                            Power BI by Category
                          </v-layout>
                          <div class="mb-7 cea-underline"></div>
                        </v-flex>
                        <v-layout column>
                          <v-flex mb-5 text-start>
                            <div v-for="(item, i) in powerBiDataCategory" :key="i" class="mb-7 banner-box">
                              <!-- <v-layout justify-start cea-color txt-head mb-3>
                                {{ item.name }}
                              </v-layout> -->
                              <v-btn absolute top fab x-small color="#FF4F23" style="right: -12px"
                                @click="removePowerBI(item.id)">
                                <v-icon color="white">close</v-icon>
                              </v-btn>
                              <!-- <v-layout justify-end>
                                <v-flex shrink pt-3 ml-10 mr-5> Name : </v-flex>
                                <v-flex xs8>
                                  <v-textarea solo flat ml-5 v-model="item.name" clearable></v-textarea>
                                </v-flex>
                              </v-layout>  -->
                              <v-layout justify-end mt-5>
                                <v-flex shrink pt-3 ml-10 mr-5> Display Order : </v-flex>
                                <v-flex xs8 style="box-shadow:none;-webkit-box-shadow:none "> 
                                  <v-select   :items="generateOptions()"  v-model="item.display_order" solo 
                                  @change="onSelectChange(item.id,item.display_order)" @click="getOldValue(item.display_order)"
                                  ></v-select>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Subject TH: </v-flex>
                                <v-flex xs8>
                                  <v-text-field clearable solo flat pl-3 v-model="item.subject_th"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Subject EN: </v-flex>
                                <v-flex xs8>
                                  <v-text-field clearable solo flat pl-3 v-model="item.subject_en"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-10 mr-5> Title TH : </v-flex>
                                <v-flex xs8>
                                  <v-textarea solo flat ml-5 v-model="item.title_th" clearable></v-textarea>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-10 mr-5> Title EN : </v-flex>
                                <v-flex xs8>
                                  <v-textarea solo flat ml-5 v-model="item.title_en" clearable></v-textarea>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Embedded URL TH : </v-flex>
                                <v-flex xs8>
                                  <v-textarea solo flat pl-3 clearable v-model="item.embed_url_th"></v-textarea>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Embedded URL EN : </v-flex>
                                <v-flex xs8>
                                  <v-textarea solo flat pl-3 clearable v-model="item.embed_url_en"></v-textarea>
                                </v-flex>
                              </v-layout>

                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Description Embed TH : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat pl-3 v-model="item.description_th"></v-textarea>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3> Description Embed EN : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat pl-3 v-model="item.description_en"></v-textarea>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-end>
                                <v-flex shrink pt-3 ml-5 mr-3>Link : </v-flex>
                                <v-flex xs8>
                                  <v-textarea clearable solo flat pl-3 v-model="item.link"></v-textarea>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                          <div style="display: flex; justify-content: right">
                            <v-btn color="#FF4F23" class="white--text mb-3" @click="addMorePowerBI('Data-and-Static')">
                              <v-icon>add</v-icon>
                            </v-btn>
                          </div>
                        </v-layout>
                      </v-layout>
                    </div>

                  </v-flex>

                </v-layout>

              </v-layout>
              <v-layout justify-end>
                <v-btn large color="#FF4F23" class="white--text mb-3" @click="savePowerBI">บันทึก</v-btn>
              </v-layout>
            </v-flex>

          </v-layout>

        </v-flex>
      </v-layout>
    </v-content>
  </div>
</template>

<script>

import { mapState } from "vuex";
import Swal from "sweetalert2";
import draggable from 'vuedraggable'
export default {
  name: "PowerBI",
  props: ["section"],
  data() {
    return {
      enabled: true,
      powerBiDataOverviewInternational: [],
      powerBiDataOverviewCountry: [],
      powerBiDataInternational: [],
      powerBiDataDefault: [],
      powerBiDataCountry: [],
      powerBiDataCategory: [],
      powerBiStatistics: [],
      old_value:0
    };
    
  },
  components: { draggable },
  async created() {
    await this.$store.dispatch("powerBi/onGetAllPowerBi")
    this.powerBiDataOverviewInternational = this.powerBiDataOverviewInternationalS
    this.powerBiDataOverviewCountry = this.powerBiDataOverviewCountryS
    this.powerBiDataInternational = this.powerBiDataInternationalS
    this.powerBiDataCountry = this.powerBiDataCountryS
    this.powerBiDataDefault = this.powerBiDataDefaultS
    this.powerBiDataCategory = this.powerBiDataCategoryS
  },
  computed: {
    ...mapState({
      userData: (state) => state.auth.userData,
      powerBiDataOverviewInternationalS: (state) => state.powerBi.powerBiDataOverviewInternational,
      powerBiDataOverviewCountryS: (state) => state.powerBi.powerBiDataOverviewCountry,
      powerBiDataInternationalS: (state) => state.powerBi.powerBiDataInternational,
      powerBiDataCountryS: (state) => state.powerBi.powerBiDataCountry,
      powerBiDataDefaultS: (state) => state.powerBi.powerBiDataDefault,
      powerBiDataCategoryS: (state) => state.powerBi.powerBiDataCategory,
      // sort จากหน้าบ้าน
      // powerBiDataCategoryS: (state) => {
      //   return state.powerBi.powerBiDataCategory.sort((a, b) => a.display_order - b.display_order)
      // },
      powerBiStatisticsS: (state) => state.powerBi.powerBiStatistics

    }),
  },

  methods: {
    // checkValidPowerBI(data){
    //   console.log("data",data)
    //   if (!data.embed_url || data.embed_url == null ||data.embed_url =="" ){
    //     console.log("false")
    //     console.log(data)
    //     return false
    //   }else {
    //     console.log("true")
    //     console.log(data)
    //     return true
    //   }
    // },
    getOldValue(param){ 
      this.old_value=param 
      alert(this.old_value);
    },
    onSelectChange(id,newValue){
      this.powerBiDataCategory.forEach((data) => {
        if (data.display_order == newValue) {
          data.display_order = this.old_value; 
        }
        if(data.id == id){
          data.display_order =newValue
        }
      });
      // Update this.powerBiDataCategory.item.display_order with the new value
      this.$set(this.powerBiDataCategory[0].item, 'display_order', newValue);
      console.log(this.powerBiDataCategory);
    },
    generateOptions() {
      const options = [];
      for (let i = 1; i <= this.powerBiDataCategory.length; i++) {
        options.push(i);
      }
      return options;
    },
    async savePowerBI() {
      let data = []
      let verify_result = 0;

      if (this.section === "creative-index-page") {
        for (const datas of this.powerBiDataInternational) {
          data.push(datas);
        }
        for (const datas of this.powerBiDataCountry) {
          data.push(datas);
        }
      }
      if (this.section === "main-page") {
        for (const datas of this.powerBiDataOverviewInternational) {
          data.push(datas);
        }
        for (const datas of this.powerBiDataOverviewCountry) {
          data.push(datas);
        }
      }
      if (this.section === "data-and-static-page") {
        for (const datas of this.powerBiDataDefault) {
          data.push(datas);
        }
        for (const datas of this.powerBiDataCategory) {
          data.push(datas);
        }
      }

      if (!data || data !== null || data.length > 0) {
        // console.log(data);
        verify_result = this.verifyInput(data);
        // console.log("verify_result",verify_result)
      }
      if (verify_result == 0) {
        this.save(data);
      } else {
        this.alertError()
      }

    },
    verifyInput(data) {
      let count_err = 0;
      // data.(datas=>{
      for (const datas of data) {
        if (!datas.embed_url_th || !datas.embed_url_en || !datas.description_th || !datas.description_en) {
          count_err++;
        }
      }
      // )
      return count_err;
    },
    alertError() {
      Swal.fire({
        icon: 'error',
        title: 'ผิดพลาด!',
        text: 'กรุณากรอกข้อมูล ให้ครบ',
      })
    },
    async save(data) {
      console.log(data);
      await this.$store.dispatch('powerBi/onUpdatePowerBi', data).then(res => {
        if (res == 200) {
          Swal.fire({
            icon: 'success',
            title: 'เรียบร้อย!',
            text: 'บันทึกข้อมูลเรียบร้อย',
          }).then((result1) => {
            location.reload();
          })
          // alert("success")
          this.$store.dispatch("powerBi/onGetAllPowerBi")
        } else {
          Swal.fire({
            icon: 'error',
            title: 'ผิดพลาด!',
            text: res,
          })
          // alert("Error",res)
        }
      })
    },
    addMorePowerBI(data) {
      switch (data) {
        case 'International':
          this.powerBiDataOverviewInternational.push({
            id: '',
            embed_url_en: '',
            embed_url_th: '',
            description_th: '',
            description_en: '',
            subject_th: '',
            subject_en: '',
            page: 'Overview-International',
            name: 'international-power-bi',
            access_token: '',
            report_id: '',
          });
          break;
        case 'Country':
          this.powerBiDataOverviewCountry.push({
            id: '',
            embed_url_en: '',
            embed_url_th: '',
            description_th: '',
            description_en: '',
            subject_th: '',
            subject_en: '',
            page: 'Overview-Country',
            name: 'country-power-bi',
            access_token: '',
            report_id: '',
          });
          break;
        case 'International-Creative':
          this.powerBiDataInternational.push({
            id: '',
            embed_url_en: '',
            embed_url_th: '',
            description_th: '',
            description_en: '',
            title_en: '',
            title_th: '',
            subject_th: '',
            subject_en: '',
            link: '',
            page: 'International',
            name: 'main-inter-power-bi',
            access_token: '',
            report_id: '',
          });
          break;
        case 'Country-Creative':
          this.powerBiDataCountry.push({
            id: '',
            embed_url_en: '',
            embed_url_th: '',
            description_th: '',
            description_en: '',
            title_en: '',
            title_th: '',
            subject_th: '',
            subject_en: '',
            link: '',
            page: 'Country',
            name: 'main-country-power-bi',
            access_token: '',
            report_id: '',

          });
          break;
        case 'Data-and-Static':
          this.powerBiDataCategory.push({
            id: '',
            name: '',
            embed_url_en: '',
            embed_url_th: '',
            description_th: '',
            description_en: '',
            title_en: '',
            title_th: '',
            subject_th: '',
            subject_en: '',
            display_order: '',
            link: '',
            page: 'DataAndStatic-Category',
            access_token: '',
            report_id: '',
          });
          break;
      }

    },
    async removePowerBI(id) {
      Swal.fire({
        title: 'ต้องการลบ?',
        showDenyButton: true,
        confirmButtonText: `ใช่`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed) {
          if (!id) {
            this.$store.dispatch("powerBi/onGetAllPowerBi")
          }
          this.$store.dispatch("powerBi/onDeletePowerBi", id).then(res => {
            if (res == 200) {
              this.$store.dispatch("powerBi/onGetAllPowerBi")
              Swal.fire({
                icon: 'success',
                title: 'เรียบร้อย!',
                text: 'เรียบร้อย!',
              }).then((result1) => {
                location.reload();
              })
            }
          })
        }
      })
    },
    checkMoveInter: function (e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    checkMoveCountry: function (e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    }

  }

};
</script>

<style>
.theme--light.v-data-table thead tr td:not(:last-child),
.theme--light.v-data-table tbody tr td:not(:last-child) {
  border-right: solid 1px #d7d7d7 !important;
}

.banner-box {
  position: relative;
  background: rgba(0, 0, 0, 0.05);
  padding: 8px 12px;
  border-radius: 6px;
}

.box-input {
  position: relative;
  background: rgba(0, 0, 0, 0.05);
  padding: 8px 12px;
  border-radius: 6px;
}

.ghost {
  opacity: 0.5;
  background: #f5a08b;
}
</style>
